import ReportSelect from "./ReportSelect";

function SadWaterDevices(props) {
  return <ReportSelect type={"sad-water-devices"} />;
}

export default SadWaterDevices;
